export class ErrorMessages {
    public static readonly STANDARD_ERROR_MESSAGE = 'Please check your internet connection and try again';
    public static readonly STANDARD_SNACK_BAR_MESSAGE = 'An error occurred while saving';
    public static readonly SNACK_BAR_ERROR_OCCURRED_WHILE = 'An error occurred while';

    public static readonly UI_ROUTE_NO_ACCESS = 'You do not have permission to access this page.';
    public static readonly LEAVE_PAGE_UNSAVED_CHANGES = 'You have unsaved changes. Are you sure you\'d like to leave this page without saving?';
}
